import { render, staticRenderFns } from "./vc-form-label.vue?vue&type=template&id=52438f17&scoped=true&"
import script from "./vc-form-label.vue?vue&type=script&lang=js&"
export * from "./vc-form-label.vue?vue&type=script&lang=js&"
import style0 from "./vc-form-label.vue?vue&type=style&index=0&id=52438f17&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52438f17",
  null
  
)

export default component.exports